// eslint-disable-next-line import/prefer-default-export
export const SELECTED_LABEL_FILTER_STRING = 'sepia(1) saturate(2.4) hue-rotate(3deg)';
